import { SET_SELECTED_MEMBER_DATA_REDUCER } from '@actions/common/actionCreators';

export const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case SET_SELECTED_MEMBER_DATA_REDUCER: {
            const { selectedMember } = action;
            return {
                ...state,
                selectedMember,
            };
        }
        default:
            return state;
    }
};